import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmtDate } from "@/lib/api";
import { paxText, sourceLabel } from "@/lib/leads";
import { LeadActions } from "./LeadActions";
import { FollowBadge, StatusSelect } from "./LeadBits";

const HEAD = ["Received", "Customer", "Requirement", "Destination / Budget", "Travel", "Guests", "Source", "Follow-up", "Status", ""];

export const LeadTable = ({ leads, onOpen, onStatus, onBook, onDelete }) => (
  <Table className="min-w-[1320px]" data-testid="leads-table">
    <TableHeader><TableRow>{HEAD.map((h) => <TableHead key={h}>{h}</TableHead>)}</TableRow></TableHeader>
    <TableBody>
      {leads.map((l) => (
        <TableRow key={l.id} data-testid={`lead-row-${l.id}`}>
          <TableCell className="text-xs text-slate-500 whitespace-nowrap">{fmtDate(l.created_at)}</TableCell>
          <TableCell>
            <button type="button" onClick={() => onOpen(l)} className="text-left" data-testid={`lead-row-open-${l.id}`}>
              <p className="font-medium text-navy hover:text-ocean">{l.name}</p><p className="text-xs text-slate-500">{l.phone}{l.email ? ` · ${l.email}` : ""}</p>
            </button>
          </TableCell>
          <TableCell className="max-w-[220px]"><p className="text-sm font-medium text-slate-700">{l.trip_type || "-"}</p><p className="text-xs text-slate-500 truncate">{l.package_name}</p></TableCell>
          <TableCell className="max-w-[200px]"><p className="text-sm text-slate-700 truncate">{l.destination || "-"}</p><p className="text-xs text-slate-500">{l.budget}</p></TableCell>
          <TableCell className="whitespace-nowrap">{fmtDate(l.travel_date)}</TableCell>
          <TableCell className="text-xs whitespace-nowrap">{paxText(l)}</TableCell>
          <TableCell className="text-sm">{sourceLabel(l.source)}</TableCell>
          <TableCell><FollowBadge lead={l} /></TableCell>
          <TableCell><StatusSelect lead={l} onChange={onStatus} /></TableCell>
          <TableCell><LeadActions lead={l} onBook={onBook} onDelete={onDelete} /></TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
